<template>
  <div class="w-full overflow-y-auto rounded-lg bg-eblack-100/70">
    <div
      class="flex flex-col p-3 overflow-y-auto border-b border-gray-200 gap-y-3 bg-slate-200"
    >
      <div class="flex flex-col gap-y-2">
        <label for="name" class="text-sm md:text-md">{{ $t("packages.auto.nombre") }}</label>
        <input
          type="text"
          name="name"
          class="text-sm rounded-md md:text-md right-1 focus:ring-blue-400"
          :placeholder="$t('packages.auto.emanta_package')"
          v-bind:class="{
            'ring-red-400': errors.length > 0 && errors.find((e) => e.name),
          }"
          v-model="form.name"
        />
        <p
          class="pl-2 text-xs text-red-400 md:text-sm"
          v-if="errors.length > 0 && errors.find((e) => e.name)"
        >
          {{ errors.find((e) => e.name).name }}
        </p>
      </div>

      <div class="flex flex-col gap-y-2">
        <label for="duration" class="text-sm md:text-md">{{ $t("packages.auto.duracion") }}</label>
        <input
          type="number"
          name="duration"
          class="text-sm rounded-md md:text-md right-1 focus:ring-blue-400"
          placeholder="10"
          v-bind:class="{
            'ring-red-400': errors.length > 0 && errors.find((e) => e.duration),
          }"
          v-model="form.duration"
        />
        <p
          class="pl-2 text-xs text-red-400 md:text-sm"
          v-if="errors.length > 0 && errors.find((e) => e.duration)"
        >
          {{ errors.find((e) => e.duration).duration }}
        </p>
      </div>

      <div class="flex flex-col gap-y-2">
        <label for="message" class="text-sm">{{ $t("packages.auto.descripcion") }}</label>
        <textarea
          rows="4"
          class="block p-2.5 w-full text-sm bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
          :placeholder="$t('packages.auto.escriba_de_que_trata_el_tour')"
          v-bind:class="{
            'ring-red-400':
              errors.length > 0 && errors.find((e) => e.description),
          }"
          v-model="form.description"
        ></textarea>

        <p
          class="pl-2 text-xs text-red-400 md:text-sm"
          v-if="errors.length > 0 && errors.find((e) => e.description)"
        >
          {{ errors.find((e) => e.description).description }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["errors"],
  name: "FormTab",
  data() {
    return {
      form: {
        name: "",
        description: "",
        duration: "",
        state: "A",
      },
    };
  },
};
</script>

<style lang="scss" scoped></style>
